<template>
  <el-dialog :visible.sync="visible" :modal-append-to-body="false">
    <div slot="title">
      {{ $t('download_center') }}
      <el-button type="text" icon="el-icon-refresh" :loading="searching" @click="getRows()"/>
    </div>
    <jbf-table v-loading="searching" :columns="columns" :data="rows"
               @selection-change="selectionChangeHandler"
               @sort-change="handleSortChange" :show-page="false">
      <template slot="progress" slot-scope="data">
        {{ data.row.progress }}%
      </template>
      <template slot="options" slot-scope="data">
        <el-button type="text" @click="download(data.row)">{{ $t('download') }}</el-button>
        <el-button type="text" @click="deleteFile(data.row,data.$index)">{{ $t('delete') }}</el-button>
      </template>
      <div style="display: inline-block;padding-top: 10px" slot="batchOptions">
        <el-button v-show="showSaveBtn" :loading="saving" @click="batchDelete()">
         {{$t('delete')}}
        </el-button>
      </div>
    </jbf-table>
  </el-dialog>
</template>

<script>
  import BasePage from "@/components/BasePage";
  import {exportDelete, exportDownload, exportList} from "@/api/remote";

  export default {
    name: "DownloadDialog",
    mixins: [BasePage],
    data() {
      return {
        visible: false,
        contractNo: null,
        selection: [],
        saving: false,
        showSaveBtn: false,
      }
    },
    computed: {
      token() {
        return this.$store.state.token;
      },
      columns() {
        return [
          {type: 'selection', width: '50px'},
          {label: this.$t('designate'), prop: 'name'},
          {label: this.$t('beginTime'), prop: 'btime'},
          {label: this.$t('endTime'), prop: 'etime'},
          {label: this.$t('state'), prop: 'progress'},
          {label: this.$t('operation'), prop: 'options', width: '100px'},
        ]
      }
    },
    methods: {
      selectionChangeHandler(selection) {
        this.selection = selection;
        this.showSaveBtn = selection.length >= 1;
      },
      getRows() {
        this.searching = true;
        let form = {};
        exportList(form).then(res => {
          this.rows = res.data;
          this.searching = false;
        }, () => this.searching = false)
      },
      download(data) {
        exportDownload({id: data.id, token: this.token})
      },
      deleteFile(data, i) {
        this.$confirm(`删除后不可下载，确定删除？`).then(res => {
          exportDelete({id: data.id}).then(res => {
            this.$message.success('操作成功');
            this.rows.splice(i, 1);
          })
        });
      },
      batchDelete() {
        let d = [];
        this.selection.forEach(item => {
          d.push(exportDelete({id: item.id}))
        });
        Promise.all(d).then(() => {
          this.getRows();
        })
      }
    },
    created() {
      // 监听是否显示
      this.$root.$on("show-download-dialog", () => {
        this.getRows();
        this.visible = true;
      })
    },
    beforeDestroy() {
      this.$root.$off("show-download-dialog")
    }
  }
</script>

<style scoped>

</style>
